import { render, staticRenderFns } from "./PayStatusReceipt.vue?vue&type=template&id=1e41092b&"
import script from "./PayStatusReceipt.vue?vue&type=script&lang=ts&"
export * from "./PayStatusReceipt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports